export const translationEs = {
    "home": "Hogar",
    "edit": "Editar",
    "_": "_",
}